import React from 'react'
import SubFooterImg from "../assets/images/news2.jpeg";
import { Link } from "react-router-dom";
const SubFooter = () => {
  return (
    <div className=' w-full flex flex-col font-opensans mt-[50px] ' >
         {/* <div className=' w-[100%] mx-auto flex flex-col gap-10 py-10 px-10 items-center justify-center  mb-[50px] mt-10 bg-[#d8bb43]' >
            <h2 className=' text-[#0e4d38] text-center font-bold text-2xl md:text-[60px] uppercase ' >Ready for what's next</h2>
           
           <div className=' flex flex-col md:flex-row items-center justify-between gap-10 ' >
                <button className=' bg-[#0e4d38] px-8 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#41a757] uppercase '
                            >Request More Info</button>
                    <button className=' bg-[#23376c] px-8 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] uppercase'
                                ><Link
                                to="https://admission.maya.edu.in/"
                                 onClick={() => {
                                    window.scrollTo(0, 0);
                                    handleLinkClick();
                                }}
                                className="font-semibold text-white transition-all duration-200 hover:text-yellow-600"
                            >
                                Apply Now
                            </Link></button>
                    <button className=' bg-[#0e4d38] px-8 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#41a757] uppercase'
                            >Explore Programs</button>
           </div>
        </div> */}
        <div
          className="relative w-full overflow-hidden bg-cover bg-[50%] bg-no-repeat">
          <img
            loading='lazy'
            src={SubFooterImg}
            className="w-full h-full object-cover" alt='House'/>
          <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-black bg-fixed opacity-50"></div>
          <div className=' absolute top-[15%] font-opensans ' >
              <div className=' w-10/12 mx-auto flex flex-col gap-5 md:gap-10  ' >
                  <h4 className=' text-4xl md:text-[52px] text-center text-white font-bold font-opensans ' >Never a dull moment in the University</h4>
                  <div className=' flex flex-col gap-10 ' >
                    <p className=' hidden md:block text-center text-slate-200  text-[12px] md:text-lg font-opensans ' >As MDU transforms into Maya Devi University, it brings with it a proud legacy of close to two decades. It will be built around its core values based on academic excellence, diversity and mutual respect, shared governance, social conscience, environmental responsibility, and more. Being an autonomous university also opens an array of opportunities. As Maya Devi University  it finds itself on a stronger global platform that will expand its international reach. In fact, it will be better placed to forge collaborations and stronger bonds with National and International universities of repute. It will result in student and faculty exchange programs that enhance the learning experience. Students of Maya Devi  University can also expect a more robust curriculum with the latest technological And managerial inputs, as it is now able to streamline and synchronize academic activities across all courses. As an autonomous university, it can exercise more flexibility in setting higher standards for admission and performance evaluation. Maya Devi University is an auspicious new beginning; not just for students but for the entire state too.</p>

                    <Link to="https://admission.maya.edu.in/"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      handleLinkClick();
                    }}
                    className=' bg-[#0e4d38] px-8 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#41a757] uppercase  self-center '
                    >
                      <button 
                                >Apply Now</button>
                    </Link>
                    
                  </div>
              </div>
          </div>
        </div>
    </div>
  )
}

export default SubFooter